export default "__VITE_ASSET__f6FjWM5f__"